/*
 * Filename: user-info.model.ts
 * Error store: This file represents the model for templates that will be displayed on homepage.
 */

import { types, ModelInstanceTypeProps, ModelProperties } from 'mobx-state-tree';
import { IUserDetailsObject } from '../../interfaces/IUser-details.interface';
import { values } from 'mobx';

export const UserDetails = types.model('UserDetailsObject', {
    UserDetailsObject: types.model({
        email: types.string,
        first_name: types.string,
        last_name: types.string,
        mobile_phone: types.string,
        username: types.string,
        fullName: types.string,
        versionNumber: types.string,
    })
}).actions((self: ModelInstanceTypeProps<ModelProperties>) => ({
    setUserData(userDetails: IUserDetailsObject) {
        self.UserDetailsObject = userDetails;
    },
    getUserData(){
        return values(self);
    }
}));
